/**
 * Modo mock do dashboard (só ativa com REACT_APP_MOCK=true).
 *
 * - seedMockSession(): grava no localStorage o token/usuário/plano fake ANTES do
 *   React montar, para o RequireAuth liberar as rotas privadas.
 * - installDashboardMock(api): troca o adapter do axios para responder com as
 *   fixtures locais, sem tocar em nenhum backend.
 *
 * Ambas são no-op quando REACT_APP_MOCK !== 'true'.
 */

import {
    MOCK_USER,
    MOCK_PLAN,
    MOCK_THEME,
    DASHBOARD_RESPONSE,
    STATUS_RESPONSE,
    BUDGET_COUNT_RESPONSE,
    MENTION_NOTIFICATIONS_RESPONSE,
} from "./dashboardFixtures";
import {
    PIPELINE_RESPONSE,
    PIPELINE_STAGE_RESPONSE,
    CARDS_LIST_RESPONSE,
    CRM_TAG_RESPONSE,
} from "./crmFixtures";

export const isMockEnabled = () => process.env.REACT_APP_MOCK === "true";

export const seedMockSession = () => {
    if (!isMockEnabled()) return;

    localStorage.setItem("token", "mock-token");
    localStorage.setItem("user", JSON.stringify(MOCK_USER));
    localStorage.setItem("plan", JSON.stringify(MOCK_PLAN));
    localStorage.setItem("theme", JSON.stringify(MOCK_THEME));
    localStorage.setItem("overdue_alert_level", "none");
    localStorage.setItem("lastPath", "/dashboard");
};

// Resolve o corpo de resposta a partir da URL da requisição.
const resolveMock = url => {
    const path = (url || "").split("?")[0];

    if (path.endsWith("/dashboard")) return DASHBOARD_RESPONSE;
    if (path.endsWith("/status")) return STATUS_RESPONSE;
    if (path.endsWith("/budget/count")) return BUDGET_COUNT_RESPONSE;
    if (path.endsWith("/mention-notifications")) return MENTION_NOTIFICATIONS_RESPONSE;
    if (path.endsWith("/notifications")) return MENTION_NOTIFICATIONS_RESPONSE;

    // CRM — a ordem importa: checar as rotas mais específicas antes de /pipeline.
    if (path.endsWith("/pipeline-stage/cards-list")) return CARDS_LIST_RESPONSE;
    if (path.endsWith("/pipeline-stage")) return PIPELINE_STAGE_RESPONSE;
    if (path.endsWith("/crm-tag")) return CRM_TAG_RESPONSE;
    if (path.endsWith("/pipeline")) return PIPELINE_RESPONSE;

    // Catch-all benigno: evita que qualquer outra chamada quebre a tela.
    // Rotas paginadas esperam `resources` como objeto {data, pagination}.
    if (path.endsWith("/paginate") || path.endsWith("/search")) {
        return {
            resources: {
                data: [],
                pagination: {
                    total: 0,
                    per_page: 15,
                    current_page: 1,
                    last_page: 1,
                    next_page_url: null,
                    prev_page_url: null,
                },
            },
        };
    }
    return { resources: [], data: [], count: 0, total: 0 };
};

export const installDashboardMock = api => {
    if (!isMockEnabled()) return;

    api.defaults.adapter = config =>
        Promise.resolve({
            data: resolveMock(config.url),
            status: 200,
            statusText: "OK (mock)",
            headers: {},
            config,
            request: {},
        });

    // eslint-disable-next-line no-console
    console.info("[mock] Dashboard em modo mock — respostas servidas localmente.");
};
